module.exports = __webpack_public_path__ + "static/media/GuideSearchPageOS10Step2.2a1461f6.gif";